import {Stack} from "@mui/material";
import React from "react";
import {ArrowRightAlt as ArrowRightAltIcon, Schedule as ScheduledAtIcon} from "@mui/icons-material";
import ContentBox from "./ContentBox";

export interface FirmwareUpdateProps {
    message: string;
    newFirmwareVersion?: {
        versionNumber: string;
    };
    oldFirmwareVersion?: {
        versionNumber: string;
    };
}
export default function FirmwareUpdate(props: FirmwareUpdateProps) {
    const {message, oldFirmwareVersion, newFirmwareVersion} = props;
    return (
        <Stack>
            <Stack
                direction="row"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                }}
            >
                <ScheduledAtIcon fontSize="inherit" />
                <ContentBox> {message}</ContentBox>
            </Stack>
            {newFirmwareVersion && (
                <Stack direction="row">
                    <ContentBox>{oldFirmwareVersion?.versionNumber}</ContentBox>
                    <ArrowRightAltIcon fontSize="small" />
                    <ContentBox>{newFirmwareVersion?.versionNumber}</ContentBox>
                </Stack>
            )}
        </Stack>
    );
}
